import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Episode from './Episode';
import TrackData from './TrackData';
// import moment from 'moment'
import {
  onAirFM as getONAirFM, onAirZD, programEpisodeWithPlaylist, fetchProgramIfNeeded
} from '~/programs/actions'
import OnAirProgram from '~/programs/components/OnAirProgram';
import { DateTime } from 'luxon';

class FortyFiveYearsOfTheZeds extends React.Component {
  constructor() {
    super()
    this.state = { shows: [] }
    let npTimeout = null
  }

   componentDidMount() {
     //const { dispatch } = this.props
     //dispatch(onAirFM())
     //dispatch(onAirZD())
  }

  componentWillMount(){
    let _this = this
    const { dispatch } = this.props
    clearTimeout(this.npTimeout)
    function getNP(_this) {
      dispatch(getONAirFM())
      dispatch(onAirZD())
      _this.npTimeout = setTimeout(getNP, 600000, _this)
    }
    this.npTimeout = setTimeout(getNP, 0, this)

		const {programs, programsFM, onAirFM} = this.props
    const soundsLike = { url:null,
      guideUrlOverride:null,
      name: "45 Years Of The Zeds",
      broadcasters: null,
      defaultFirstAiredGuide:"fm",
      slug: "45-years-of-the-zeds",
      start: "07:00:00"
    }
		dispatch(fetchProgramIfNeeded(soundsLike.slug))

    if(onAirFM.key && programsFM.items.length) {
      let shows = [

        {...soundsLike, title: 'Since 1975', reverse: true, height: '95vh'}
      ]
      let datestring = '2020-12-08'

      shows.map((item) => {
        if (! programs[item.slug]) {
          dispatch(programEpisodeWithPlaylist(item.slug, datestring))
        }
      })
      this.setState({shows: shows})
    }
  }

  componentWillUnmount() {
    clearTimeout(this.npTimeout)
  }

  componentWillReceiveProps(nextProps){

  }

  render(){
    const { programs, programsFM, onAirFM } = this.props
    const { shows } = this.state
    const showsGuide = shows.map((item, index) => {
      var episode, playlist
      let nowDate = DateTime.local().setZone("Australia/Brisbane").toISODate('YYYY-MM-DD')

			if ( programs && programs[item.slug] && programs[item.slug].episodes && programs[item.slug].episodes.episodeIndex) {

				return programs[item.slug].episodes.episodeIndex.map((i,n) => <div key={n}>
					<OnAirProgram program={item} episode={programs[item.slug].episodes[i]} playlist={playlist} title={item.title} height={item.height} reverse={item.reverse}/>
				</div>)
			}
      else {
        return null
      }
    })

    return (
      <div>
        {showsGuide}
      </div>
    )
  }
}
export default connect(state => ({programs: state.programs, programsFM: state.programsFM, onAirFM: state.onAirFM})) (FortyFiveYearsOfTheZeds)
